import { render, staticRenderFns } from "./WordCluster.vue?vue&type=template&id=df348be2&"
import script from "./WordCluster.vue?vue&type=script&lang=js&"
export * from "./WordCluster.vue?vue&type=script&lang=js&"
import style0 from "./WordCluster.vue?vue&type=style&index=0&id=df348be2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports